import React,  { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import {COMPANY_NAME} from "../../constants/constants";
import CommunitySvg from '../../../images/community.svg';
import VPng from '../../../images/v.png';
import Bro from '../../../images/bro.svg';

export default function LeadConfirmation(props) {

    const [cta, setCta] = useState(`Continue to ${COMPANY_NAME}'s Community`);
    const [ctaClicked, setCtaClicked] = useState(false);

    const onCtaClicked = () => {
        setCta('Redirecting...');
        setCtaClicked(true);
    }

    const thumbImages = [CommunitySvg, VPng, Bro];
    for (const image of thumbImages) {
        const imageElement = new Image();
        imageElement.src = image;
    }

    const renderFeatures = () => {
        if(props.includeFeatures) {
            return (
                <>
                    <div className={'mt-3 d-flex justify-content-center'}>
                        <img src={VPng} />
                        <span className={'ps-2'}>Over 56,000 enterprise tech reviews</span>
                    </div>

                    <div className={'mt-2 d-flex justify-content-center'}>
                        <img src={VPng} />
                        <span className={'ps-2'}>Over 600,000 community members</span>
                    </div>

                    <div className={'mt-2 d-flex justify-content-center'}>
                        <img src={VPng} />
                        <span className={'ps-2'}>Over 15,000 buyer's guides</span>
                    </div>
                </>
            )
        }
    }

    return (
        <>
            <Modal.Header className={'border-bottom-0 pt-4 pb-0 justify-content-center text-center'}>
                <Modal.Title className={'fs-4 mb-0'}>
                    {props.header}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className={'text-secondary text-center px-2 px-sm-4 mx-1 pt-0'}>
                <div className={'mb-4 secondary-links fs-6 mx-auto'}>
                    {props.subHeader}
                </div>

                <img src={props.peerTalkConfirm ? Bro : CommunitySvg} />

                {renderFeatures()}

                {props.includeRedirect ? <a href={props.redirectPath} onClick={onCtaClicked}>
                    <Button variant="primary" className={'btn-block btn-hover-cursor mt-4'} disabled={ctaClicked}>
                        {cta}
                    </Button>
                </a> : '' }

            </Modal.Body>
        </>
    )
}
